import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { scrollbar } from 'utils';

export const StyledLayout = styled('div')(
  () => css`
    height: 100%;
    min-height: 100%;

    .layout {
      display: flex;
      min-height: 100%;
      height: 100%;

      &.is-sidebar-menu-collapsed {
        .layout-sidebar-sticky {
          min-width: 80px;
          max-width: 80px;
        }
      }

      .layout-sidebar-sticky {
        min-width: 258px;
        max-width: 258px;

        .layout-sidebar {
          .nav-section {
            height: calc(100vh - 70px);
            overflow-y: auto;
            overflow-x: hidden;
            ${scrollbar(4, 'transparent', 'transparent')};

            &:hover {
              ${scrollbar(4, 'rgba(0, 0, 0, 0.1)', '#f1f1f1')};
            }
          }
          &.with-chat-widget {
            .nav-section {
              height: calc(100vh - 115px);
            }
          }
        }
      }

      .layout-main {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;

        .layout-body {
          padding: 0 33px 33px;
          overflow-y: auto;
          overflow-x: hidden;
          ${scrollbar(0, '#333')};
          flex: 1;
        }
      }
    }

    @media (max-width: 960px) {
      .layout {
        .layout-sidebar-sticky {
          min-width: unset !important;
          max-width: unset !important;
        }
        .layout-main {
          .layout-body {
            padding: 0 16px 16px;
          }
        }
      }
    }
  `
);
